export default __webpack_public_path__ + "static/media/Transparent-Logo.de8cfdea.png";